import { MESSAGE, REGEX } from "../constant";

export const validateEmail = (email) => {
    if (email === "") {
        return MESSAGE.THIS_REQUEIRED_FIELD;
    }
    if (!REGEX.EMAIL.test(email)) { 
        return MESSAGE.EMAIL_INVALID;
    }
    return "";
}


export const validateLoginPassword = (password) => { 
    if (password === "") {
        return MESSAGE.THIS_REQUEIRED_FIELD;
    }
    return "";
}


export const validateNewPassword = (password) => { 
    const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;

    if (password === "") {
        return MESSAGE.THIS_REQUEIRED_FIELD;
    }
    if(!re.test(password)) {
        return MESSAGE.NEW_PASSWORD_INVALID;
    }
    return "";
}
export const validateConfirmPassword = (newPassowrd, confirmPassword) => { 
    if (confirmPassword === "") {
        return MESSAGE.THIS_REQUEIRED_FIELD;
    }
    if (newPassowrd !== confirmPassword) {
        return MESSAGE.CONFIRM_PASSWORD_INVALID;
    }
    return "";
}


export const validateName = (name) => { 
    if (name === "") {
        return MESSAGE.THIS_REQUEIRED_FIELD;
    }
    if (name.split(" ").length > 1) {
        return MESSAGE.FIRST_NAME_SPACE_INVALID;
    }
    return "";
}

export const validateLastName = (name) => { 
    if (name === "") {
        return MESSAGE.THIS_REQUEIRED_FIELD;
    }
    if (name.split(" ").length > 1) {
        return MESSAGE.LAST_NAME_SPACE_INVALID;
    }
    return "";
}

export const validateDate = (date) => { 
    if (date === "") {
        return MESSAGE.THIS_REQUEIRED_FIELD;
    }
    return "";
}

export const validatePhone = (phone) => {
    const re = /^\d{10}$/;

    if (phone === "") {
        return MESSAGE.THIS_REQUEIRED_FIELD;
    }
    if(!re.test(phone)) {
        return MESSAGE.PHONE_INVALID;
    }
    return "";
}

export const validatePincode = (phone) => {
    const re = /\d{6}/;

    if (phone === "") {
        return MESSAGE.THIS_REQUEIRED_FIELD;
    }
    if(!re.test(phone)) {
        return MESSAGE.PINCODE_INVALID;
    }
    return "";
}

export const validateURL = (url) => {
    try {
        if (url === "") {
            return MESSAGE.THIS_REQUEIRED_FIELD;
        }
        new URL(url);
        return "";
      } catch (err) {
        return MESSAGE.INVALID_URL;
      }
}
